import * as React from "react";
import { useLocation, useSearch } from "wouter";
import { ArrowLeft, PackageSearch } from "lucide-react";
import { UnplacedRelocateLists, type ListMode } from "./UnplacedRelocateLists.js";

/**
 * Organize entry point for the Unplaced & Re-locate lists (P0-B). The SAME
 * component also mounts inside Inventory (R-B3) — this is just the Organize
 * surface's route wrapper. `?list=relocate|unplaced` selects the initial tab so
 * deep links (e.g. from the home "needs you now" region) land on the right list.
 */
export default function OrganizeListsPage() {
  const [, navigate] = useLocation();
  const search = useSearch();
  const initialMode: ListMode = new URLSearchParams(search).get("list") === "relocate" ? "relocate" : "unplaced";

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <header>
        <button
          onClick={() => navigate("/organize")}
          className="inline-flex items-center gap-1 text-sm text-faint hover:text-primary transition-colors mb-2"
        >
          <ArrowLeft className="w-4 h-4" />Organize
        </button>
        <div className="flex items-center gap-2 mb-1">
          <PackageSearch className="w-5 h-5 text-primary" />
          <span className="text-sm font-medium text-primary">Sort it out</span>
        </div>
        <h1 className="text-4xl font-semibold text-ink font-headline tracking-[-0.02em]">Unplaced &amp; Re-locate</h1>
        <p className="text-body mt-1 text-sm">Two lists: things with no home yet, and things you flagged to move.</p>
      </header>

      <UnplacedRelocateLists initialMode={initialMode} />
    </div>
  );
}
